import React, { useState, useEffect } from 'react';
import PropTypes from 'prop-types';
import { translate } from 'helpers/translateHelper';


import './style.scss';
import NotificationStatusBarContent from './NotificationStatusBarContent';
import { NOTIFICATION_BAR } from 'helpers/constants';
import { formatDate } from 'helpers/dateTimeFormatter';

const NotificationStatusBar = ({ model: { assetSubscriptionInfo, subscription }, showClose, coloredIcon }) => {
	const [isHide, setIsHide] = useState(false);
	const [value, setValue] = useState(false);

	// REVERT TO THIS while adding the blue and yellow banner
	// useEffect(() => {
	// 	if (assetSubscriptionInfo) {
	// 		actions.setContractNotification(assetSubscriptionInfo);
	// 	} else {
	// 		actions.closeNotificationBar();
	// 		setIshide(isHide);

	// 	}
	// }, [assetSubscriptionInfo, isHide]);

	useEffect(() => {
		if (assetSubscriptionInfo === NOTIFICATION_BAR.FREE_FOR_RENEWAL || assetSubscriptionInfo === NOTIFICATION_BAR.FREE) {
			setIsHide(true);
			setValue(false);
		} else {
			setIsHide(false);
			setValue(true);
		}
	}, [assetSubscriptionInfo]);


	useEffect(() => {
		if (translate(subscription?.contractInfo?.message) === translate('ABB.Powertrain.Frontend.AssetIsUnmonitored')) {
			setValue(true);
			setIsHide(false);
		}
	}, [subscription?.contractInfo]);

	const contractInfoWithFormattedDate = subscription?.contractInfo?.messageParams?.endDate
		? {
			...subscription.contractInfo,
			messageParams: {
				...subscription.contractInfo.messageParams,
				endDate: subscription.contractInfo.messageParams?.endDate
					? formatDate(subscription.contractInfo.messageParams.endDate)
					: subscription.contractInfo.messageParams?.endDate,
			},
		}
		: subscription?.contractInfo;


	const onClose = () => {
		// REVERT TO THIS while adding the blue and yellow banner
		// actions.closeNotificationBar(notification);
		// if (props.onClose) {
		// 	props.onClose(notification);
		// }
		setIsHide(false);
		setValue(false);
		/* ADJUST AVAILABLE SPACE */
		const tabContent = document.getElementsByClassName('tab-content-with-notification');
		if (tabContent && tabContent.length > 0) {
			tabContent[0].classList.remove('tab-content-with-notification');
		}
	};

	return (
		assetSubscriptionInfo === NOTIFICATION_BAR.FREE_FOR_RENEWAL || assetSubscriptionInfo === NOTIFICATION_BAR.FREE || subscription?.contractInfo ? <NotificationStatusBarContent notification={assetSubscriptionInfo} onClose={onClose} isHide={isHide} contractInfo={contractInfoWithFormattedDate} value={value} showClose={showClose} coloredIcon={coloredIcon} /> : null
	);

};

NotificationStatusBar.propTypes = {
	model: PropTypes.shape({
		assetSubscriptionInfo: PropTypes.oneOfType([
			PropTypes.oneOf(Object.values(NOTIFICATION_BAR)), // Notification type constants
			PropTypes.string, // Notification type (e.g., FREE, FREE_FOR_RENEWAL)
			PropTypes.number, // Notification type as a numeric value
		]), // Asset subscription information
		subscription: PropTypes.shape({
			contractInfo: PropTypes.shape({
				message: PropTypes.string, // Contract message
				type: PropTypes.string, // Contract type
				messageParams: PropTypes.shape({
					endDate: PropTypes.oneOfType([PropTypes.string, PropTypes.instanceOf(Date), PropTypes.number]),
				}),
				link: PropTypes.shape({
					description: PropTypes.string, // Link description
					url: PropTypes.string, // Link URL
				}), // Link details
			}), // Contract information
		}), // Subscription details
	}), // Model containing state data
	showClose: PropTypes.bool,
	coloredIcon: PropTypes.bool,
};

export default React.memo(NotificationStatusBar);

